<template>
    <div class="tree-control">
        <div class="tree-input" @click="setShowTree(true)" :style="{width: wide+'px'}">
            <el-input v-model="input" placeholder="新美集团" @blur="hideThree"></el-input> <i class="el-icon-arrow-down" :class="{'rotateZ': getShowTree}" ></i>
            <div class="tree-box" v-show="getShowTree" :style="{width: (wide-2)+'px'}">
                <el-tree :data="treelist" @node-click="handleNodeClick" :default-expand-all="true"></el-tree>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState,mapGetters, mapActions,mapMutations} from 'vuex';
export default {
    data() {
        return {
            showTree: false,
            input: '',
        }
    },
    computed: {
        ...mapGetters(['getShowTree'])
    },
    props: [
        'treelist',
        'wide'
    ],
    watch: {
        input() {
            if (this.input == '') {
                this.$emit('changeVal', '');
            }
        }
    },
    methods: {
        ...mapMutations(['setShowTree']),
        handleNodeClick(data) {
            this.input = data.label;
            this.setShowTree(false);
            this.$emit('changeVal', data.orgCode);
            // this.$emit('changeVal', {label: data.label, orgCode: data.orgCode});
        },
        hideThree() {
            setTimeout(() => {
                this.setShowTree(false);
            }, 200)
        }
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
.tree-control{
    i.el-icon-arrow-down {
    position: absolute;
    top: 11px;
    left: 176px;
    transition: all 0.5s;
    // transform: rotateZ(-180deg);
    }
    .rotateZ {
        transform: rotateZ(-180deg);
    }
    .el-input--suffix .el-input__inner {
        cursor: pointer;
    }
    .tree-input{
        position: relative;
        .tree-box{
            max-height: 300px;
            overflow-x: hidden;
            border: 1px solid #DCDFE6;
            border-radius: 4px;
            box-shadow: 0 2px 12px 0 #DCDFE6;
            background: #fff;
            position: absolute;
            z-index: 10;
            padding: 10px 0;
        }
    }

}
@media screen and (max-width: 768px) {
    .tree-control{
        width: 140px !important;

        i.el-icon-arrow-down{
            position: absolute;
            top: 10px;
            left: 112px;
            color:#c4cbde;
        }
        .tree-input{
            .tree-box {
                width: 140px !important;
            }
        }
    }
}
</style>
<style lang="scss">
.tree-control{
    .el-input__inner {
    height: 33px;
    }
}
</style>


// WEBPACK FOOTER //
// OrganizationalStructure.vue?6ecc0d48